import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { AlertSuppressionSetting } from './AlertWithSuppressionDialog';
import { useEventConfirmationDialogSuppressionTimestamp } from './useEventConfirmationDialogSuppressionTimestamp';

export function useRelativeFloorPriceDropDialog(
  onOkay: () => void,
  onCancel: () => void,
  viagogoVirtualId?: string | null
) {
  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );

  const eventLastTimeStamp = useEventConfirmationDialogSuppressionTimestamp(
    'relativeFloorPriceDropSuppressionTimestamp',
    viagogoVirtualId
  );

  const lastTimeStamp =
    hasSellerEventAlertMutesFeature && viagogoVirtualId
      ? eventLastTimeStamp
      : null;

  const key: keyof AlertSuppressionSetting =
    'relativeFloorPriceDropSuppressionTimestamp';
  return {
    key,
    onOkay,
    onCancel,
    lastTimeStamp,
    bodyText: <Content id={ContentId.RelativeFloorPriceDropWarning} />,
  };
}
